/**
 * Indikátor délky textu u každé textarea s atributem maxlength.
 *
 * Jediná konfigurace je ten atribut — pole ho má, indikátor se pod ním objeví.
 * Textarea může do stránky přibýt až AJAXem (košík, formuláře ve snippetech),
 * proto se kromě delegovaného posluchače sleduje i přírůstek DOMu.
 */

const INDICATOR_CLASS = 'textarea-length-indicator';

/**
 * Varovně se indikátor rozsvítí posledních 30 znaků. U krátkých polí by ale
 * pevných 30 svítilo skoro pořád, proto se práh zároveň drží na pětině limitu.
 */
const WARNING_LIMIT = 30;
const WARNING_RATIO = 0.2;

/**
 * Vazba pole na jeho indikátor. Přes sousedství v DOMu ji vést nelze — mezi pole
 * a indikátor se umí vklínit chybová hláška formuláře.
 */
const indicators = new WeakMap<HTMLTextAreaElement, HTMLElement>();

export function initialize() {
    document.addEventListener('input', function (e) {
        let target = e.target;

        if (target instanceof HTMLTextAreaElement) {
            update(target);
        }
    });

    let observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node instanceof Element) {
                    attachAll(node);
                }
            });
        });
    });

    observer.observe(document.documentElement, {childList: true, subtree: true});

    attachAll(document.documentElement);
}

function attachAll(root: Element) {
    if (root instanceof HTMLTextAreaElement) {
        attach(root);
    }

    root.querySelectorAll('textarea[maxlength]').forEach(function (textarea) {
        if (textarea instanceof HTMLTextAreaElement) {
            attach(textarea);
        }
    });
}

function attach(textarea: HTMLTextAreaElement) {
    // Bez atributu vrací maxLength -1; dvojí připojení by pod pole dalo dva indikátory.
    if (textarea.maxLength <= 0 || indicators.has(textarea)) {
        return;
    }

    let indicator = document.createElement('div');
    indicator.className = 'form-text text-end ' + INDICATOR_CLASS;
    textarea.insertAdjacentElement('afterend', indicator);
    indicators.set(textarea, indicator);

    update(textarea);
}

function update(textarea: HTMLTextAreaElement) {
    let indicator = indicators.get(textarea);

    if (indicator === undefined) {
        return;
    }

    let limit = textarea.maxLength;
    // value.length počítá UTF-16 jednotky stejně jako maxlength, takže indikátor
    // ukazuje totéž, co prohlížeč dovolí napsat. Serverová validace nad mb_strlen
    // se od toho u emoji rozejde — rozhoduje ona, tohle je orientační.
    let length = textarea.value.length;
    let remaining = limit - length;

    indicator.textContent = length + '/' + limit;
    indicator.classList.toggle('is-over-limit', remaining < 0);
    indicator.classList.toggle('is-near-limit', remaining >= 0 && remaining <= Math.min(WARNING_LIMIT, limit * WARNING_RATIO));
}
